// TODO - https://qbe-appservices.atlassian.net/browse/AD1-438

import type { SvgIconComponent } from '@mui/icons-material';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import { Icon, Link } from '@qbe/ads-core';
import * as React from 'react';

type LinkButtonProps = {
  disabled?: boolean;
  onClick: () => unknown;
  label: string;
  muiIcon?: SvgIconComponent;
  sx?: SystemStyleObject;
  href?: string;
  id?: string;
  dataTrack?: string;
};

// TODO - various issues https://qbe-appservices.atlassian.net/browse/AD1-429

const LinkButton: React.FC<LinkButtonProps> = ({
  disabled = false,
  onClick,
  href,
  label,
  muiIcon,
  sx = {},
  id,
  dataTrack,
}) => (
  <Link
    id={id}
    component="button"
    type="button"
    data-track={dataTrack}
    onClick={() => {
      if (disabled) {
        return;
      }
      onClick();
    }}
    href={href}
    underline="hover"
    sx={[
      {
        gap: 1,
        marginTop: 2,
        display: muiIcon ? 'flex' : 'inline-block',
        fontWeight: 'fontWeightMedium',
        cursor: 'pointer',
      },
      disabled // TODO - required until disabled props is supported
        ? {
            cursor: 'default',
            color: 'grey',
            '&:hover': {
              textDecoration: 'none',
            },
          }
        : {},
      typeof sx !== 'undefined' ? sx : {},
    ]}
  >
    {label}
    {typeof muiIcon !== 'undefined' ? (
      <Icon muiIcon={muiIcon} color={disabled ? 'grey' : 'primary'} />
    ) : null}
  </Link>
);

export default LinkButton;
